/**
 * MentorMessage — single chat bubble inside the Mentor drawer.
 *
 * Extracted from MentorDrawer.jsx (Feb 2026 A1 refactor).
 * Pure presentation — receives a single `msg` and renders a bubble
 * styled for either the user (right-aligned, brand wash) or the
 * mentor bot (left-aligned, neutral card).
 *
 * The drawer's append-only message list maps over this for every
 * turn in the active conversation thread.
 */
import { Bot, User as UserIcon } from "lucide-react";
import GlossaryHighlight from "../GlossaryHighlight";

export default function MentorMessage({ msg }) {
  const isUser = msg.role === "user";
  return (
    <div
      className={`flex items-start gap-2 ${isUser ? "flex-row-reverse" : ""}`}
      data-testid={`mentor-msg-${msg.role}`}
    >
      <div
        className={`w-7 h-7 flex items-center justify-center flex-shrink-0 ${
          isUser ? "bg-[#4A4458] text-white" : "bg-[#7C5FB0] text-white"
        }`}
      >
        {isUser ? (
          <UserIcon className="w-4 h-4" />
        ) : (
          <Bot className="w-4 h-4" />
        )}
      </div>
      <div className={`max-w-[80%] ${isUser ? "items-end text-right" : ""}`}>
        <div className="text-[9px] uppercase tracking-[0.2em] text-neutral-400 mb-0.5">
          {isUser ? "You" : "Mentor"}
        </div>
        <div
          className={`text-sm leading-relaxed whitespace-pre-wrap px-3 py-2 ${
            isUser
              ? "bg-[#EFF6FF] text-neutral-900"
              : "bg-neutral-50 border border-neutral-200 text-neutral-800"
          }`}
        >
          {/* Jun 2026 · Mentor answers run through GlossaryHighlight so
              jargon in the bot's reply is clickable, same as the plan. */}
          {!isUser && typeof msg.text === "string" ? (
            <GlossaryHighlight text={msg.text} />
          ) : (
            msg.text
          )}
        </div>
      </div>
    </div>
  );
}
